import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import InputMask from "react-input-mask";
import "../styles/add_date.css";
import "react-select-search/style.css";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import Select from "react-select";
import emailjs from "@emailjs/browser";

const MySwal = withReactContent(Swal2);

const AddDate = (props) => {
  const [date, setDate] = useState(
    props.mode === "edit" ? props.hearingData.date : ""
  );
  const [time, setTime] = useState(
    props.mode === "edit" ? props.hearingData.time : ""
  );
  const [court, setCourt] = useState(
    props.mode === "edit" ? props.hearingData.court : ""
  );
  const [name, setName] = useState("");
  const [sygn, setSygn] = useState(
    props.mode === "edit" ? props.hearingData.sygn : ""
  );
  const [form, setForm] = useState(
    props.mode === "edit" ? props.hearingData.form : "stacjonarna"
  );
  const [url, setUrl] = useState(
    props.mode === "edit" ? props.hearingData.online_url : ""
  );
  const [bank, setBank] = useState(
    props.mode === "edit" ? props.hearingData.bank : ""
  );
  const [wps, setWps] = useState(
    props.mode === "edit"
      ? props.hearingData.wps
      : props.place === "client"
      ? props.client.wps
      : ""
  );
  const [caseD, setCaseD] = useState(
    props.mode === "edit" ? props.hearingData.subject : ""
  );
  const [mode] = useState(props.mode);
  const [lawyer, setLawyer] = useState(
    props.mode === "edit" ? props.hearingData.lawyer : ""
  );
  const [lawyerOri, setLawyerOri] = useState(
    props.mode === "edit" ? props.hearingData.lawyer : ""
  );
  const [lawyer_form, setLawyerForm] = useState(
    props.mode === "edit" ? props.hearingData.lawyer_form : ""
  );
  const [substitute_name, setSubstituteName] = useState(
    props.mode === "edit" ? props.hearingData.substitute_name : ""
  );
  const [guardian_name, setGuardianName] = useState(
    props.mode === "edit" ? props.hearingData.guardian_name : ""
  );
  const [result, setResult] = useState(
    props.mode === "edit" ? props.hearingData.result : ""
  );
  const [result_type, setResultType] = useState(
    props.mode === "edit" ? props.hearingData.result_type : ""
  );
  const [result_note, setResultNote] = useState(
    props.mode === "edit" ? props.hearingData.result_note : ""
  );
  const [note, setNote] = useState(
    props.mode === "edit" ? props.hearingData.note : ""
  );
  const [client, setClient] = useState(
    props.mode === "main" ? "" : props.client
  );
  const [clientId, setClientId] = useState("");
  const [clients, setClients] = useState([]);
  const [clientsSygn, setClientsSygn] = useState("");
  const [loading, setLoading] = useState(true);
  const [courtOri, setCourtOri] = useState("");
  const [sygnOri, setSygnOri] = useState("");
  const [clientsOptions, setClientsOptions] = useState([]);
  const [courtOptions, setCourtOptions] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [substitutesOptions, setSubstitutesOptions] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [weekArray, setWeekArray] = useState([]);
  const [addF, setAddF] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [results, setResults] = useState([]);

  const getInitials = (user) => {
    var newData = props.usersData.filter((el) => el.name === user);
    if (newData.length > 0) {
      return newData[0].initials;
    } else {
      return "";
    }
  };

  const addDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() + days);
    return dateN;
  };

  const subDays = (date, days) => {
    var dateN = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    dateN.setDate(dateN.getDate() - days);
    return dateN;
  };

  const getDateOfWeek = (w, y) => {
    var d = 1 + (w - 1) * 7;

    if (new Date(y, 0, d).getFullYear() === 2023) {
      return new Date(y, 0, d + 1);
    } else if (new Date(y, 0, d).getFullYear() === 2024) {
      return new Date(y, 0, d);
    } else if (y === 2025) {
      return subDays(new Date(y, 0, d), 2);
    } else {
      return new Date(y, 0, d);
    }
  };

  const fetchClients = async () => {
    if (props.place === "client" || props.mode === "edit") {
      setCourtOri(props.client.aCourt);
      setSygnOri(props.client.aSygn);
      setCourt(props.client.aCourt);
      setSygn(props.client.aSygn);
      fetchHolidays();
      return;
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          if (props.place === "client") {
            setCourtOri(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnOri(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
            setCourt(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygn(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
          }
          fetchHolidays();
        })
        .catch((error) => {});
    }
  };

  const fetchClientsAll = async () => {
    if (props.place === "client" || props.mode === "edit") {
      setCourtOri(props.client.aCourt);
      setSygnOri(props.client.aSygn);
      setCourt(props.client.aCourt);
      setSygn(props.client.aSygn);
      fetchHolidays();
      return;
    } else {
      var body = {
        team: props.team,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsListAddDateAll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          data = getAllowedClients(data).filter((el) => el.arch === "0");
          setClients(data);
          setClientsOptions(createClientsOptions(data));
          if (props.place === "client") {
            setCourtOri(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygnOri(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
            setCourt(
              data.filter((el) => el.id === props.client.id)[0].aCourt ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aCourt
            );
            setSygn(
              data.filter((el) => el.id === props.client.id)[0].aSygn ===
                "brak danych"
                ? ""
                : data.filter((el) => el.id === props.client.id)[0].aSygn
            );
          }
          fetchHolidays();
        })
        .catch((error) => {});
    }
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchResults2();
      })
      .catch((error) => {});
  };

  const fetchResults2 = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getExpectedResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResults(data);
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        fetchResults();
      })
      .catch((error) => {});
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getHearingSubject", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSubjects(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.id === +el));
      });
      return arr;
    }
  };

  const fetchClientsSygn = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getClientsSygn", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClientsSygn(data);
        if (props.place === "client") {
          setCourtOri(
            getActualCourtForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualCourtForClientData(props.client.id, data)
          );
          setSygnOri(
            getActualSygnForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualSygnForClientData(props.client.id, data)
          );
          setCourt(
            getActualCourtForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualCourtForClientData(props.client.id, data)
          );
          setSygn(
            getActualSygnForClientData(props.client.id, data) === "brak danych"
              ? ""
              : getActualSygnForClientData(props.client.id, data)
          );
        }
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    if (props.team === 0) {
      fetchClientsAll();
    } else {
      fetchClients();
    }

    setCourtOptions(createCourtOptions());
    setSubstitutesOptions(createSubstitutesOptions());
    //fetchClientsSygn();
  };

  useEffect(() => {
    getData();
  }, []);

  const createWeekSet = async (data) => {
    var date = data.date;

    var startYear = new Date(date).getFullYear();
    var startDate = new Date(new Date(date).getFullYear(), 0, 1);
    var days = Math.floor((new Date(date) - startDate) / (24 * 60 * 60 * 1000));

    var weekNumber = Math.ceil(days / 7);
    var weekStartDate = getDateOfWeek(
      new Date(date).getDay() === 1 ? weekNumber + 1 : weekNumber,
      startYear
    );
    var weekEndDate = addDays(weekStartDate, 6);

    var weekArrayB = [];

    for (var i = 0; i <= 6; ++i) {
      var actualDate = addDays(weekStartDate, i);

      weekArrayB.push(
        `${actualDate.getFullYear()}-${
          actualDate.getMonth() < 10
            ? "0" + (actualDate.getMonth() + 1)
            : actualDate.getMonth() + 1
        }-${
          actualDate.getDate() < 10
            ? "0" + actualDate.getDate()
            : actualDate.getDate()
        }`
      );
    }

    setWeekArray(weekArrayB);

    var body = {
      dateFrom: weekStartDate,
      dateTo: weekEndDate,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsDateAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearings(data);
      })
      .catch((error) => {});
  };

  const handleDateChange = (e) => {
    setDate(e.target.value);
    if (mode === "edit") {
      var data = { date: e.target.value };
      createWeekSet(data);
    }
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
  };

  const handleSygnChange = (e) => {
    setSygn(e.target.value);
  };

  const handleCourtChange = (e) => {
    setCourt(e.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleFormChange = (e) => {
    setForm(e.target.value);
  };

  const handleUrlChange = (e) => {
    setUrl(e.target.value);
  };

  const handleBankChange = (e) => {
    setBank(e);
  };

  const handleWpsChange = (e) => {
    setWps(e.target.value.replaceAll(" ", ""));
  };

  const handleCaseChange = (e) => {
    setCaseD(e.target.value);
  };

  const handleLawyerChange = (e) => {
    setLawyer(e.target.value);
    if (mode === "edit") {
      var data = { date: date };
      createWeekSet(data);
    }
  };

  const handleLawyerFormChange = (e) => {
    if (e.target.value === "Osobiście") {
      setSubstituteName("");
      setGuardianName("");
    }
    setLawyerForm(e.target.value);
  };

  const handleSubstituteNameChange = (e) => {
    setSubstituteName(e.value);
  };

  const handleGuardianNameChange = (e) => {
    setGuardianName(e.value);
  };

  const handleResultChange = (e) => {
    setResult(e.target.value);
  };

  const handleResultTypeChange = (e) => {
    setResultType(e.target.value);
  };

  const handleResultNoteChange = (e) => {
    setResultNote(e.target.value);
  };

  const handleNoteChange = (e) => {
    setNote(e.target.value);
  };

  const getClientName = () => {
    var client = "";
    clients.map((el) => {
      if (client === "") {
        client += el.name;
      } else {
        client += " , " + el.name;
      }
    });

    return client;
  };

  const checkClientName = (name, hearings) => {
    var nameArr = name.split(",");
    var res = false;

    var l = hearings.filter((e) => e.name === name).length;
    if (l > 0) {
      res = true;
    }
    return res;
  };

  const addClientSygn = async () => {
    var addX = false;
    MySwal.fire({
      title: "Czy dodawana sygnatura jest sygnaturą poboczną?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        addX = true;
        if (court !== courtOri || sygn !== sygnOri) {
          var body = {
            clientId: props.place === "client" ? props.client.id : clientId,
            sygn: sygn,
            date:
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              new Date().getHours() +
              ":" +
              (new Date().getMinutes() < 10
                ? "0" + new Date().getMinutes()
                : new Date().getMinutes()) +
              ":" +
              new Date().getSeconds(),
            court: court,
            who: props.place === "client" ? props.user.name : props.user.name,
            add: addX,
          };

          await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        }
      } else if (result.isDenied) {
        addX = false;
        if (court !== courtOri || sygn !== sygnOri) {
          var body = {
            clientId: props.place === "client" ? props.client.id : clientId,
            sygn: sygn,
            date:
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              new Date().getHours() +
              ":" +
              (new Date().getMinutes() < 10
                ? "0" + new Date().getMinutes()
                : new Date().getMinutes()) +
              ":" +
              new Date().getSeconds(),
            court: court,
            who: props.place === "client" ? props.user.name : props.user.name,
            add: addX,
          };

          await fetch("https://apidevkppp.ftpeople.pl/addSygnClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});
        }
      }
    });
  };

  const addDate = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();

    var body = {
      name: client.petitioner,
      date: date,
      time: time,
      court: court,
      bank: client.bank,
      sygn: sygn,
      wps: wps,
      form: form,
      online_url: url,
      subject: caseD,
      date_added: date_added,
      user_added: props.user.name,
      accepted: "no",
      status: "DO SPRAWDZENIA",
      readed: "no",
      clientId: client.id,
      team: props.place === "client" ? props.client.team : client.team,
    };

    if (
      mode !== "edit" &&
      new Date(date) >=
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        )
    ) {
      if (validateForm()) {
        var body2 = {
          team: props.place === "client" ? props.client.team : client.team,
        };

        fetch("https://apidevkppp.ftpeople.pl/getHearings", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body2),
        })
          .then((response) => response.json())
          .then(async (data) => {
            //if(false){
            if (
              data.filter(
                (el) =>
                  el.name === client.petitioner &&
                  new Date(el.date).getFullYear() +
                    "-" +
                    new Date(el.date).getMonth() +
                    "-" +
                    new Date(el.date).getDate() ===
                    new Date(date).getFullYear() +
                      "-" +
                      new Date(date).getMonth() +
                      "-" +
                      new Date(date).getDate()
              ).length > 0
            ) {
              MySwal.fire({
                title:
                  "Istnieje podobny termin rozprawy zapisany w tym okresie dla tego klienta. Czy na pewno chcesz dodać?",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Tak",
                denyButtonText: `Nie`,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await fetch("https://apidevkppp.ftpeople.pl/insertDate", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});

                  var body2 = {
                    id: props.place === "client" ? props.client.id : clientId,
                    wps: wps,
                  };

                  fetch("https://apidevkppp.ftpeople.pl/addWPSClient", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body2),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});

                  addClientSygn();
                  MySwal.fire({
                    icon: "success",
                    title: "Dodano",
                    text: "nowy termin rozprawy",
                  }).then((result) => {
                    props.close();
                  });
                  props.handleOptionChangeClose("calendar");
                } else if (result.isDenied) {
                }
              });
            } else {
              await fetch("https://apidevkppp.ftpeople.pl/insertDate", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});

              var body2 = {
                id: props.place === "client" ? props.client.id : clientId,
                wps: wps,
              };

              fetch("https://apidevkppp.ftpeople.pl/addWPSClient", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body2),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});

              addClientSygn();

              MySwal.fire({
                icon: "success",
                title: "Dodano",
                text: "nowy termin rozprawy",
              }).then((result) => {
                props.close();
              });
              props.handleOptionChangeClose("calendar");
            }
          })
          .catch((error) => {});
      } else {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "Wypełnij wymagane pola formularza",
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Data rozprawy musi nastąpić w przyszłości!",
      });
    }
  };

  const validateForm = () => {
    if (
      date === "" ||
      time === "" ||
      form === "" ||
      wps === "" ||
      sygn === "" ||
      court === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleAddClient = (e) => {
    var check = e.target.value.split(" ").length > 1;
    if (check) {
      if (e.target.value === "") {
        return;
      } else {
        clients.push({ id: Math.random() * 100, name: e.target.value });
        setName("");
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Imię i nazwisko niepoprawne",
      });
    }
  };

  const handleDeleteClient = (e) => {
    var newArray = clients.filter((el) => el.id !== +e.target.value);
    setClients(newArray);
  };

  const checkHoliday = () => {
    var blocks = holidays.filter((el) => el.user === lawyer);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= date && el.date_from <= date) ||
          (date >= el.date_from && date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const saveEditAccept = () => {
    if (!checkHoliday()) {
      saveEdit();
    } else {
      MySwal.fire({
        title:
          "Osoba, której chcesz przypisać rozprawę jest w tym czasie na urlopie. Czy nadal chcesz jej przypisać rozprawę?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          saveEdit();
        } else if (result.isDenied) {
          return;
        }
      });
    }
  };

  const saveEdit = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();

    if (validateForm()) {
      setLoading(true);

      var body = {
        id: props.id,
        name: props.hearingData.name,
        date: date,
        time: time,
        court: court,
        bank: bank,
        sygn: sygn,
        wps: wps,
        form: form,
        online_url: url,
        subject: caseD,
        date_modified: date_added,
        user_modified: props.user.name,
        lawyer: lawyer,
        lawyer_form: lawyer_form,
        substitute_name: substitute_name,
        guardian_name: guardian_name,
        result: result,
        result_type: result_type,
        result_note: result_note,
        note: note,
        clientId: props.hearingData.clientId,
      };

      var bodyXX = {
        new: JSON.stringify(body),
        old: JSON.stringify(props.hearingData),
        user: props.user.name,
        hearingId: props.hearingData.id,
      };

      fetch("https://apidevkppp.ftpeople.pl/addHearingHistory", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyXX),
      })
        .then((response) => response.text())
        .then((data) => {});

      await fetch("https://apidevkppp.ftpeople.pl/editDate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          if (lawyerOri !== lawyer) {
            emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
            var templateParams = {
              to:
                props.usersData.filter((el) => el.name === lawyerOri).length > 0
                  ? props.usersData.filter((el) => el.name === lawyerOri)[0]
                      .mail
                  : "",
              name: props.hearingData.name,
              date_date: props.hearingData.date + " " + props.hearingData.time,
              court: props.hearingData.court,
              sygn: props.hearingData.sygn,
              subject:
                "Do rozprawy przypisano innego prawnika - " +
                lawyer +
                ": " +
                props.hearingData.name +
                ", " +
                props.hearingData.date +
                " " +
                props.hearingData.time,
              user_name: props.user.name,
              newLawyer: lawyer,
            };

            emailjs.send("KPPP", "template_u82qy0d", templateParams).then(
              function (response) {
                var templateParams2 = {
                  to:
                    props.usersData.filter((el) => el.name === lawyer).length >
                    0
                      ? props.usersData.filter((el) => el.name === lawyer)[0]
                          .mail
                      : "",
                  name: props.hearingData.name,
                  date_date:
                    props.hearingData.date + " " + props.hearingData.time,
                  court: props.hearingData.court,
                  sygn: props.hearingData.sygn,
                  subject:
                    "Została Ci przypisana rozprawa: " +
                    props.hearingData.name +
                    ", " +
                    props.hearingData.date +
                    " " +
                    props.hearingData.time,
                  user_name: props.user.name,
                };

                emailjs.send("KPPP", "template_711ldto", templateParams2).then(
                  function (response) {
                    var body2 = {
                      id: props.hearingData.clientId,
                      wps: wps,
                    };

                    fetch("https://apidevkppp.ftpeople.pl/addWPSClient", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body2),
                    })
                      .then((response) => response.json())
                      .then((data) => {})
                      .catch((error) => {});

                    MySwal.fire({
                      icon: "success",
                      title: "Edytowano",
                      text: "termin rozprawy",
                    }).then((result) => {
                      props.close();
                    });
                    props.close();
                  },
                  function (error) {
                    MySwal.fire({
                      icon: "error",
                      title: "Błąd",
                      text: "nie wysłano wiadomości e-mail. Ponów operację!",
                    }).then(async (result) => {
                      props.close();
                    });
                  }
                );
              },
              function (error) {
                MySwal.fire({
                  icon: "error",
                  title: "Błąd",
                  text: "nie wysłano wiadomości e-mail. Ponów operację!",
                }).then(async (result) => {
                  props.close();
                });
              }
            );
          } else {
            var body2 = {
              id: props.hearingData.clientId,
              wps: wps,
            };

            fetch("https://apidevkppp.ftpeople.pl/addWPSClient", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Edytowano",
              text: "termin rozprawy",
            }).then((result) => {
              props.close();
            });
            props.close();
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const checkDigit = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const createCourtOptions = () => {
    var courtsOptions = [];
    getCourtsForTeam().map((el) => {
      courtsOptions.push({ label: el.name, value: el.name });
    });
    return courtsOptions;
  };

  const createBankOptions = () => {
    var banksOptions = [];
    getBanksForTeam().map((el) => {
      banksOptions.push({ name: el.name, value: el.name });
    });
    return banksOptions;
  };

  const createSubstitutesOptions = () => {
    var substitutesOptions = [];
    if (props.substitutes) {
      props.substitutes.map((el) => {
        substitutesOptions.push({ label: el.name, value: el.name });
      });
    }

    return substitutesOptions;
  };

  const getLawyersForTeam = (e) => {
    var usersForTeam = [];

    props.lawyers.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === +props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getBanksForTeam = (e) => {
    var usersForTeam = [];

    props.banksData.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getCourtsForTeam = (e) => {
    var usersForTeam = [];

    props.courtsData.map((el) => {
      if (
        el.team
          .split(",")
          .filter((el2) =>
            +props.team === 0 ? +el2 === 1 || +el2 === 2 : +el2 === +props.team
          ).length > 0
      ) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const handleClientChange = (e) => {
    setClientId(e.value);
    var client = clients.filter((el) => +el.id === +e.value)[0];
    setClient(client);
    setWps(client.wps);
    setCourtOri(
      clients.filter((el) => el.id === client.id)[0].aCourt === "brak danych"
        ? ""
        : clients.filter((el) => el.id === client.id)[0].aCourt
    );
    setSygnOri(
      clients.filter((el) => el.id === client.id)[0].aSygn === "brak danych"
        ? ""
        : clients.filter((el) => el.id === client.id)[0].aSygn
    );
    setCourt(
      clients.filter((el) => el.id === client.id)[0].aCourt === "brak danych"
        ? ""
        : clients.filter((el) => el.id === client.id)[0].aCourt
    );
    setSygn(
      clients.filter((el) => el.id === client.id)[0].aSygn === "brak danych"
        ? ""
        : clients.filter((el) => el.id === client.id)[0].aSygn
    );
  };

  const getActualCourtForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const getActualSygnForClient = (clientId) => {
    var sygns = clientsSygn.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const getActualCourtForClientData = (clientId, data) => {
    var sygns = data.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].court !== ""
        ? sygns[0].court
        : "brak danych"
      : "brak danych";
  };

  const getActualSygnForClientData = (clientId, data) => {
    var sygns = data.filter((el) => +el.clientId === +clientId);
    sygns.sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });
    return sygns.length > 0
      ? sygns[0].sygn.length > 4
        ? sygns[0].sygn
        : "brak danych"
      : "brak danych";
  };

  const createClientsOptions = (data) => {
    var bankOptions = [];
    data.map((el) => {
      bankOptions.push({
        label:
          el.petitioner +
          " | " +
          (data.filter((el2) => el2.id === el.id)[0].aSygn === "brak danych"
            ? el.credit_value
            : data.filter((el2) => el2.id === el.id)[0].aSygn),
        value: el.id,
      });
    });
    return bankOptions;
  };

  const createHearingButtonWeek = (hearing, date) => {
    var dateH = new Date(hearing.date);
    var dateR = new Date(date);
    if (
      dateH.getFullYear() === dateR.getFullYear() &&
      dateH.getMonth() === dateR.getMonth() &&
      dateH.getDate() === dateR.getDate()
    ) {
      return (
        <>
          <button
            style={
              hearing.result === "Odwołana z nowym terminem" ||
              hearing.result === "Odwołana bez terminu"
                ? { backgroundColor: "#757573" }
                : hearing.subject === "Ogłoszenie wyroku"
                ? { backgroundColor: "#7db541" }
                : hearing.form === "online"
                ? { backgroundColor: "#e3a74b" }
                : { backgroundColor: "#0b315f" }
            }
            key={hearing.id}
            id="weekLink"
            className="caseLink"
            value={hearing.id}
            onClick={() => {
              return;
            }}
          >
            <div className="titleBox">
              <div className="titleBox_col1">
                {hearing.name} {getInitials(hearing.lawyer)}
              </div>
              <div className="titleBox_col2">
                {hearing.accepted === "yes" ? (
                  <span id="calendar_check" className="highlight_blue">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.status === "SPRAWDZONO" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
                {hearing.arch === "1" ? (
                  <span id="calendar_check" className="highlight_green">
                    ✓
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </button>
        </>
      );
    }
  };

  const calendarWeek = (
    <>
      {hearings.filter((l) => l.lawyer === lawyer).length > 0 ? (
        <>
          <div className="rowCalendar">
            {weekArray.map((el) => (
              <>
                <div key={el} className="colWeekCalendar">
                  <div className="weekContent">
                    <p className="colWeekTitle">
                      {new Date(el).getFullYear()}-
                      {new Date(el).getMonth() + 1 < 10
                        ? "0" + (new Date(el).getMonth() + 1)
                        : new Date(el).getMonth() + 1}
                      -
                      {new Date(el).getDate() < 10
                        ? "0" + new Date(el).getDate()
                        : new Date(el).getDate()}
                    </p>
                    {hearings
                      .filter((l) => l.lawyer === lawyer)
                      .map((el2) => (
                        <>{createHearingButtonWeek(el2, el)}</>
                      ))}
                  </div>
                </div>
              </>
            ))}
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );

  return (
    <>
      <div
        style={{ paddingRight: "2%", paddingTop: "2%" }}
        className="closeBox"
      >
        <button className="closeClientButton" onClick={props.close}>
          X
        </button>
      </div>
      <div className="mainContainerAddDate">
        {loading ? (
          <LoadingPopup />
        ) : (
          <>
            <div className="inputContainer">
              {props.place === "client" ? (
                <>
                  <span
                    style={{
                      fontSize: "1.5vw",
                      textTransform: "uppercase",
                      fontWeight: "900",
                    }}
                  >
                    Klient: {client.petitioner}{" "}
                    {props.team === 0 ? "- zespół " + client.team : ""}
                  </span>
                </>
              ) : (
                ""
              )}

              {props.modeAdd === "main" ? (
                <>
                  <div style={{ width: "66%" }} className="inputBox">
                    <div className="inputCol_1">
                      <label>
                        Klient <span className="requiredStar">*</span>
                      </label>
                      <Select
                        noOptionsMessage={() => "Brak danych"}
                        placeholder={"Wybierz..."}
                        isClearable={false}
                        options={clientsOptions}
                        onChange={handleClientChange}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>
                    WPS <span className="requiredStar">*</span>
                  </label>
                  <InputMask
                    mask="999 999 999 999"
                    maskChar=" "
                    type="text"
                    id="signature"
                    name="signature"
                    value={wps}
                    onChange={handleWpsChange}
                    onKeyPress={checkDigit}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Sygnatura akt <span className="requiredStar">*</span>
                  </label>
                  <input
                    type="text"
                    id="signature"
                    name="signature"
                    value={sygn}
                    onChange={handleSygnChange}
                  />
                </div>
                <div className="inputCol_3">
                  <label>
                    Sąd <span className="requiredStar">*</span>
                  </label>
                  <Select
                    noOptionsMessage={() => "Brak danych"}
                    placeholder={"Wybierz..."}
                    isClearable={false}
                    options={courtOptions}
                    value={{ label: court, value: court }}
                    onChange={handleCourtChange}
                  />
                </div>
              </div>

              {mode !== "edit" ||
              (mode === "edit" && props.user.role === "admin") ? (
                <>
                  <div className="inputBox">
                    <div className="inputCol_3">
                      <label>
                        Data rozprawy <span className="requiredStar">*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        name="date"
                        value={date}
                        onChange={handleDateChange}
                        min="2002-01-01"
                      />
                    </div>
                    <div className="inputCol_3">
                      <label>
                        Godzina rozprawy <span className="requiredStar">*</span>
                      </label>
                      <input
                        type="time"
                        id="time"
                        name="time"
                        value={time}
                        onChange={handleTimeChange}
                        min="2002-01-01"
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="inputBox">
                {mode !== "edit" ||
                (mode === "edit" &&
                  (props.user.role === "user" ||
                    props.user.role === "admin")) ? (
                  <div className="inputCol_3">
                    <label>
                      Forma rozprawy <span className="requiredStar">*</span>
                    </label>
                    <select
                      type="text"
                      id="form"
                      name="form"
                      value={form}
                      onChange={handleFormChange}
                    >
                      {form === "" ? (
                        <option key="0" value="no">
                          Wybierz z listy...
                        </option>
                      ) : (
                        ""
                      )}
                      <option key="2" value="stacjonarna">
                        Stacjonarna
                      </option>
                      <option key="1" value="online">
                        Online
                      </option>
                    </select>
                  </div>
                ) : (
                  ""
                )}
                {mode !== "edit" ||
                (mode === "edit" &&
                  (props.user.role === "user" ||
                    props.user.role === "admin")) ? (
                  <div className="inputCol_3">
                    <label>Przedmiot rozprawy</label>
                    <select
                      type="text"
                      id="form"
                      name="form"
                      value={caseD}
                      onChange={handleCaseChange}
                    >
                      {caseD === "" ? (
                        <option key="0" value="no">
                          Wybierz z listy...
                        </option>
                      ) : (
                        ""
                      )}
                      {subjects
                        ? subjects.map((e) => (
                            <>
                              <option key={e.id} value={e.name}>
                                {e.name}
                              </option>
                            </>
                          ))
                        : ""}
                    </select>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {mode !== "edit" ||
              (mode === "edit" &&
                (props.user.role === "user" || props.user.role === "admin")) ? (
                <div className="inputBox">
                  {form === "online" ? (
                    <div className="inputCol_1">
                      <label>Link do rozprawy</label>
                      <input
                        type="text"
                        id="url"
                        name="url"
                        value={url}
                        onChange={handleUrlChange}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
              {mode === "edit" ? (
                <>
                  {props.hearingData.lawyer ? (
                    <>
                      <div className="inputBox">
                        {props.user.role === "admin" ? (
                          <div className="inputCol_3">
                            <label>Prawnik odpowiedzialny</label>
                            <select
                              type="text"
                              id="court"
                              name="court"
                              value={lawyer}
                              onChange={handleLawyerChange}
                            >
                              {lawyer === "" ? (
                                <option key="0" value="no">
                                  Wybierz z listy...
                                </option>
                              ) : (
                                ""
                              )}
                              {getLawyersForTeam().map((el) => (
                                <option key={el.name} value={el.name}>
                                  {el.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : (
                          ""
                        )}
                        {mode !== "edit" ||
                        (mode === "edit" &&
                          (props.user.role === "user" ||
                            props.user.role === "admin")) ? (
                          <>
                            <div className="inputCol_3">
                              <label>Forma reprezentacji</label>
                              <select
                                type="text"
                                id="court"
                                name="court"
                                value={lawyer_form}
                                onChange={handleLawyerFormChange}
                              >
                                {lawyer_form === "" ? (
                                  <option key="0" value="no">
                                    Wybierz z listy...
                                  </option>
                                ) : (
                                  ""
                                )}
                                <option key={"0b"} value="Osobiście">
                                  Osobiście
                                </option>
                                <option key={"1b"} value="Substytut">
                                  Substytut
                                </option>
                                <option key={"2b"} value="Opiekun">
                                  Opiekun
                                </option>
                              </select>
                            </div>
                            {lawyer_form === "Substytut" ? (
                              <>
                                <div className="inputCol_3">
                                  <label>Imię i nazwisko substytuta</label>
                                  <Select
                                    noOptionsMessage={() => "Brak danych"}
                                    placeholder={"Wybierz..."}
                                    isClearable={false}
                                    value={{
                                      label: substitute_name,
                                      value: substitute_name,
                                    }}
                                    options={substitutesOptions}
                                    onChange={handleSubstituteNameChange}
                                  />
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                            {lawyer_form === "Opiekun" ? (
                              <>
                                <div className="inputCol_3">
                                  <label>Imię i nazwisko substytuta</label>
                                  <Select
                                    noOptionsMessage={() => "Brak danych"}
                                    placeholder={"Wybierz..."}
                                    isClearable={false}
                                    value={{
                                      label: guardian_name,
                                      value: guardian_name,
                                    }}
                                    options={substitutesOptions}
                                    onChange={handleGuardianNameChange}
                                  />
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      {lawyer ? (
                        <>
                          <p>
                            ROZPRAWY PRAWNIKA W TYGODNIU (
                            {hearings.filter((l) => l.lawyer === lawyer).length}
                            )
                          </p>
                          {calendarWeek}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {props.hearingData.result &&
                  mode === "edit" &&
                  props.user.role === "admin" ? (
                    <>
                      <div className="inputBox">
                        <div className="inputCol_3">
                          <label>Wynik rozprawy</label>
                          <select
                            type="text"
                            id="court"
                            name="court"
                            value={result}
                            onChange={handleResultChange}
                          >
                            {result === "" ? (
                              <option key="0" value="no">
                                Wybierz z listy...
                              </option>
                            ) : (
                              ""
                            )}
                            {results.map((r) => (
                              <option key={r.name} value={r.name}>
                                {r.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        {result === "Wyrok" ? (
                          <>
                            <div className="inputCol_3">
                              <label>Rodzaj wyroku</label>
                              <select
                                type="text"
                                id="court"
                                name="court"
                                value={result_type}
                                onChange={handleResultTypeChange}
                              >
                                {result_type === "" ? (
                                  <option key="0" value="no">
                                    Wybierz z listy...
                                  </option>
                                ) : (
                                  ""
                                )}
                                {props.results.map((el) => (
                                  <option key={el.name} value={el.name}>
                                    {el.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      {result === "Wyrok" ||
                      result === "Odroczenie z terminem" ||
                      result === "Odroczenie bez terminu" ||
                      result === "Odroczenie z terminem  + zobowiązanie" ||
                      result === "Odroczenie bez terminu + zobowiązanie" ? (
                        <>
                          <div className="inputBox">
                            <div className="inputCol_1">
                              <label>Notatka do terminu</label>
                              <textarea
                                spellcheck="false"
                                className="textAreaNote"
                                type="text"
                                id="url"
                                name="url"
                                value={result_note}
                                onChange={handleResultNoteChange}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {props.hearingData.note &&
                  mode === "edit" &&
                  props.user.role === "admin" ? (
                    <>
                      <div className="inputBox">
                        <div className="inputCol_1">
                          <label>Notatka</label>
                          <textarea
                            spellcheck="false"
                            className="textAreaNote"
                            type="text"
                            id="url"
                            name="url"
                            value={note}
                            onChange={handleNoteChange}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
            <div className="acceptButtonContainer">
              <button
                className="acceptButton"
                onClick={mode === "edit" ? saveEditAccept : addDate}
              >
                {mode === "edit" ? "ZAPISZ" : "DODAJ TERMIN ROZPRAWY"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddDate;
